var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app-bar',{attrs:{"clipped-left":"","app":"","color":"primary","dense":"","dark":""}},[_c('v-toolbar-title',{staticClass:"text-body-1"},[_vm._v("SafetyPlanner")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }